export default "__VITE_ASSET__DChd69e$__"